import {match} from 'ts-pattern';

import {PostCorrectiveTaxDocumentIssueApiArg} from '@dms/api/sales';

import {getApiDateString, Nullish, parseDate} from 'shared/web';

import {AccountingDocumentFormValues} from '../../../types';

const formatDateString = (date: string | Nullish) =>
  date ? getApiDateString(parseDate(date)) : '';

export function mapFormDataToRequestBody(
  formData: AccountingDocumentFormValues,
  isFullCorrection: boolean
): PostCorrectiveTaxDocumentIssueApiArg['body'] {
  return {
    correctiveTaxDocumentType: isFullCorrection ? 'full-correction' : 'partial-correction',
    dueDate: formatDateString(formData.dueDate),
    dateOfTaxableSupply: formatDateString(formData.dateOfTaxableSupply),
    issueDate: formatDateString(formData.issueDate),
    dateOfReception: formatDateString(formData.dateOfReception),
    reason: formData.reason ?? '',
    behindItemsNote: formData.footerNote ?? undefined,
    internalNote: formData.internalNote ?? null,
    items: isFullCorrection
      ? undefined
      : (formData.invoiceItems?.map((item) => ({
          quantity: Number(item.quantity ?? 0),
          priceUnit: Number(item.pricePerUnit ?? 0),
          isPriceUnitWithVat: item.isUnitPriceWithVat ?? false,
          vatType: item.vatType ?? '',
          currency: formData.currency ?? '',
          type: item.type ?? 'standard',
        })) ?? []),
    additionalCustomer:
      formData.additionalCustomer?.customer.id && formData.additionalCustomer.contractInformationId
        ? {
            customerId: formData.additionalCustomer.customer.id,
            contractInformationId: formData.additionalCustomer.contractInformationId,
            type: formData.additionalCustomer.type ?? 'OPERATOR',
          }
        : undefined,
    customFields: formData.customFieldsPayload ?? [],
    invoiceCategory: formData.isInternal ? 'internal' : undefined,
    paymentInfo: {
      paymentMethod: match(formData.paymentInfo.paymentMethod)
        .with('FREE_OF_CHARGE', 'OFFSET', () => 'INTERNAL' as const)
        .otherwise((method) => method),
      bankAccount: formData.paymentInfo.bankAccount ?? undefined,
      bankName: formData.paymentInfo.bankName ?? undefined,
      iban: formData.paymentInfo.iban ?? undefined,
      swift: formData.paymentInfo.swift ?? undefined,
      variableSymbol: formData.paymentInfo.variableSymbol ?? undefined,
      constantSymbol: formData.paymentInfo.constantSymbol ?? undefined,
      specificSymbol: formData.paymentInfo.specificSymbol ?? undefined,
    },
    exchangeRate: formData.exchangeRateRatio
      ? {
          amount: Number(formData.exchangeRateRatio.amount ?? 1),
          ratio: formData.exchangeRateRatio.ratio ?? '',
          currency: formData.exchangeRateRatio.currency ?? '',
        }
      : undefined,
  };
}
